module.exports = __webpack_public_path__ + "static/media/recharging-your-battery-large@2x.21f89007.png";